// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchCategory, updateCategory } from '../../Slice/Category/categorySlice';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { AsyncPaginate } from "react-select-async-paginate";
// import { getData, serverURL } from '../../services/FetchNodeServices';

// const EditCategory = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { _id } = useParams();
//   const category = useSelector((state) => state.category.category);

//   const [productList, setProductList] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [data, setData] = useState({
//     categoryname: '',
//     metaTagTitle: '',
//     metaTagDescription: '',
//     metaTagKeywords: '',
//     keywords: '',
//     image: null,
//     imagePreview: '',
//     thumbnail: null,
//     thumbnailPreview: '',
//     active: false,
//     productId: [],
//   });

//   // Fetch category on mount
//   useEffect(() => {
//     dispatch(fetchCategory(_id));
//   }, [dispatch, _id]);

//   // Set form data from fetched category
//   useEffect(() => {
//     if (category) {
//       setData((prev) => ({
//         ...prev,
//         categoryname: category.name || '',
//         metaTagTitle: category.meta_title || '',
//         metaTagDescription: category.meta_description || '',
//         metaTagKeywords: category.meta_keyword || '',
//         keywords: category.keyword || '',
//         imagePreview: category.image || '',
//         thumbnailPreview: category.thumbnail || '',
//         active: category.status === '1' || category.status === 1 || category.status === true,
//         productId: JSON.parse(category?.productId) || [],
//       }));
//     }
//   }, [category]);

//   // Fetch product list on mount

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setData((prev) => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleImageChange = (e, field) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       toast.error('File size must be under 2MB');
//       return;
//     }
//     const preview = URL.createObjectURL(file);
//     setData((prev) => ({
//       ...prev,
//       [field]: file,
//       [`${field}Preview`]: preview,
//     }));
//   };

//   const handleProductChange = (selectedOptions) => {
//     const selectedIds = selectedOptions.map((opt) => opt.value);
//     setData((prev) => ({
//       ...prev,
//       productId: selectedIds,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append('name', data.categoryname);
//     formData.append('meta_title', data.metaTagTitle);
//     formData.append('meta_description', data.metaTagDescription);
//     formData.append('meta_keyword', data.metaTagKeywords);
//     formData.append('keyword', data.keywords);
//     formData.append('status', data.active ? 1 : 0);
//     formData.append('existingImage', data.imagePreview);
//     formData.append('existingThumbnail', data.thumbnailPreview);
//     formData.append('productId', JSON.stringify(data.productId));

//     if (data.image) formData.append('image', data.image);
//     if (data.thumbnail) formData.append('thumbnail', data.thumbnail);

//     setLoading(true);
//     try {
//       const res = await dispatch(updateCategory({ id: _id, formData })).unwrap();
//       toast.success(res?.message || 'Category updated successfully');
//       navigate('/all-category');
//     } catch (error) {
//       toast.error(error?.message || 'Failed to update category');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderImagePreview = (preview) => {
//     if (!preview) return null;
//     const imageUrl = preview.startsWith('blob:')
//       ? preview
//       : `${serverURL}/uploads/images/${preview}`;
//     return <img src={imageUrl} alt="Preview" height="100" style={{ marginTop: 10 }} />;
//   };

//     const loadProductOptions = async (search, loadedOptions, { page }) => {
//       try {
//         const res = await getData(`product/get-all-product?page=${page}&limit=20&search=${search || ""}`);
//         if (res.status) {
//           const newOptions = res.data.map((product) => ({
//             value: product.id,
//             label: product.name,
//           }));
  
//           return {
//             options: newOptions,
//             hasMore: res.data.length === 20,
//             additional: { page: page + 1 },
//           };
//         } else {
//           toast.error(res.message || "Failed to load products");
//           return { options: [], hasMore: false };
//         }
//       } catch (error) {
//         toast.error("Error loading products");
//         console.error("Product fetch error:", error);
//         return { options: [], hasMore: false };
//       }
//     };

//   return (
//     <>
//       <ToastContainer />
//       <div className="bread">
//         <div className="head">
//           <h4>Edit Category</h4>
//         </div>
//         <div className="links">
//           <Link to="/all-category" className="add-new">
//             Back <i className="fa-regular fa-circle-left"></i>
//           </Link>
//         </div>
//       </div>

//       <div className="d-form">
//         <form onSubmit={handleSubmit}>
//           <div className="row mb-3">
//             {/* Category name and meta fields */}
//             {[
//               { label: 'Category Name', name: 'categoryname' },
//               { label: 'Meta Tag Title', name: 'metaTagTitle' },
//               { label: 'Meta Tag Description', name: 'metaTagDescription' },
//               { label: 'Meta Tag Keywords', name: 'metaTagKeywords' },
//               { label: 'Keywords', name: 'keywords' }
//             ].map(({ label, name }) => (
//               <div key={name} className={`col-md-${name === 'metaTagDescription' ? '12' : '6'} mt-2`}>
//                 <label className="form-label">
//                   {label} <sup className="text-danger">*</sup>
//                 </label>
//                 <input
//                   type="text"
//                   name={name}
//                   className="form-control"
//                   value={data[name]}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//             ))}

//             {/* Linked Products */}
//             <div className="col-md-6 mb-3">
//               <label className="form-label">
//                 Link Products <sup className="text-danger">*</sup>
//               </label>
//               <AsyncPaginate
//                 inputId="productSelect"
//                 isMulti
//                 placeholder="Search and select products..."
//                 classNamePrefix="react-select"
//                 additional={{ page: 1 }}
//                 value={(data.productId || [])
//                   .map((id) => {
//                     const product = productList.find((p) => p?.id === id);
//                     return product ? { value: product.id, label: product.name } : null;
//                   })
//                   .filter(Boolean)}
//                 loadOptions={loadProductOptions}
//                 onChange={(selectedOptions) => {
//                   const selectedIds = selectedOptions
//                     ? selectedOptions.map((opt) => opt.value)
//                     : [];

//                   setData((prev) => ({
//                     ...prev,
//                     productId: selectedIds,
//                   }));

//                   const allSelected = selectedOptions || [];
//                   const allProducts = allSelected.map((opt) => ({
//                     id: opt.value,
//                     name: opt.label,
//                   }));

//                   setProductList((prevList) => {
//                     const unique = [
//                       ...prevList,
//                       ...allProducts.filter((p) => !prevList.find((x) => x.id === p.id)),
//                     ];
//                     return unique;
//                   });
//                 }}
//               />
//             </div>

//             {/* Images */}
//             <div className="col-md-6 mt-2">
//               <label className="form-label">Category Banner Image</label>
//               <input
//                 type="file"
//                 name="image"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={(e) => handleImageChange(e, 'image')}
//               />
//               {renderImagePreview(data.imagePreview)}
//             </div>

//             <div className="col-md-6 mt-2">
//               <label className="form-label">Category Thumbnail Image</label>
//               <input
//                 type="file"
//                 name="thumbnail"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={(e) => handleImageChange(e, 'thumbnail')}
//               />
//               {renderImagePreview(data.thumbnailPreview)}
//             </div>

//             {/* Active Checkbox */}
//             <div className="col-md-6 d-flex align-items-center mt-3">
//               <input
//                 type="checkbox"
//                 name="active"
//                 checked={data.active}
//                 onChange={handleInputChange}
//                 id="active"
//                 style={{ marginRight: 8 }}
//               />
//               <label htmlFor="active">Active</label>
//             </div>
//           </div>

//           <button type="submit" className="mybtnself" disabled={loading}>
//             {loading ? 'Updating...' : 'Update Category'}
//           </button>
//         </form>
//       </div>
//     </>
//   );
// };

// export default EditCategory;

import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategory, updateCategory } from '../../Slice/Category/categorySlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AsyncPaginate } from 'react-select-async-paginate';
import { getData, serverURL } from '../../services/FetchNodeServices';

const EditCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { _id } = useParams();
  const category = useSelector((state) => state.category.category);

  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);

  const [data, setData] = useState({
    categoryname: '',
    metaTagTitle: '',
    metaTagDescription: '',
    metaTagKeywords: '',
    keywords: '',
    image: null,
    imagePreview: '',
    thumbnail: null,
    thumbnailPreview: '',
    active: false,
    productId: [],
  });

  useEffect(() => {
    dispatch(fetchCategory(_id));
  }, [dispatch, _id]);

  useEffect(() => {
    if (category) {
      setData((prev) => ({
        ...prev,
        categoryname: category.name || '',
        metaTagTitle: category.meta_title || '',
        metaTagDescription: category.meta_description || '',
        metaTagKeywords: category.meta_keyword || '',
        keywords: category.keyword || '',
        imagePreview: category.image || '',
        thumbnailPreview: category.thumbnail || '',
        active: category.status === '1' || category.status === 1 || category.status === true,
        productId: JSON.parse(category.productId || '[]'),
      }));
    }
  }, [category]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const validateImage = (file) => {
    if (file && file.size > 2 * 1024 * 1024) {
      toast.error('Image must be under 2MB');
      return false;
    }
    return true;
  };

  const handleImageChange = (e, field) => {
    const file = e.target.files[0];
    if (!file || !validateImage(file)) return;

    const preview = URL.createObjectURL(file);
    setData((prev) => ({
      ...prev,
      [field]: file,
      [`${field}Preview`]: preview,
    }));
  };

  const loadProductOptions = async (search, loadedOptions, { page }) => {
    try {
      const res = await getData(
        `product/get-all-product?page=${page}&limit=20&search=${search || ''}`
      );
      if (res.status) {
        const newOptions = res.data.map((product) => ({
          value: product.id,
          label: product.name,
        }));

        return {
          options: newOptions,
          hasMore: res.data.length === 20,
          additional: { page: page + 1 },
        };
      } else {
        toast.error(res.message || 'Failed to load products');
        return { options: [], hasMore: false };
      }
    } catch (error) {
      toast.error('Error loading products');
      return { options: [], hasMore: false };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', data.categoryname);
    formData.append('meta_title', data.metaTagTitle);
    formData.append('meta_description', data.metaTagDescription);
    formData.append('meta_keyword', data.metaTagKeywords);
    formData.append('keyword', data.keywords);
    formData.append('status', data.active ? 1 : 0);
    formData.append('existingImage', data.imagePreview);
    formData.append('existingThumbnail', data.thumbnailPreview);
    formData.append('productId', JSON.stringify(data.productId));

    if (data.image) formData.append('image', data.image);
    if (data.thumbnail) formData.append('thumbnail', data.thumbnail);

    setLoading(true);
    try {
      const res = await dispatch(updateCategory({ id: _id, formData })).unwrap();
      toast.success(res.message || 'Category updated successfully');
      navigate('/all-category');
    } catch (error) {
      toast.error(error?.message || 'Failed to update category');
    } finally {
      setLoading(false);
    }
  };

  const renderImagePreview = (preview) => {
    if (!preview) return null;
    const imageUrl = preview.startsWith('blob:')
      ? preview
      : `${serverURL}/uploads/images/${preview}`;
    return (
      <img
        src={imageUrl}
        alt="Preview"
        height="100"
        style={{ marginTop: 10, borderRadius: 4 }}
      />
    );
  };
// console.log("DATA:++>=>",data)
  return (
    <>
      <ToastContainer />
      <div className="bread">
        <div className="head">
          <h4>Edit Category</h4>
        </div>
        <div className="links">
          <Link to="/all-category" className="add-new">
            Back <i className="fa-regular fa-circle-left"></i>
          </Link>
        </div>
      </div>

      <div className="d-form">
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">

            {/* Form Fields */}
            {[
              { label: 'Category Name', name: 'categoryname' },
              { label: 'Meta Tag Title', name: 'metaTagTitle' },
              { label: 'Meta Tag Description', name: 'metaTagDescription' },
              { label: 'Meta Tag Keywords', name: 'metaTagKeywords' },
              { label: 'Keywords', name: 'keywords' },
            ].map(({ label, name }) => (
              <div
                key={name}
                className={`col-md-${name === 'metaTagDescription' ? '12' : '6'} mt-2`}
              >
                <label className="form-label">
                  {label} <sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  name={name}
                  value={data[name]}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                />
              </div>
            ))}

            {/* Linked Products */}
            <div className="col-md-6 mt-3">
              <label className="form-label">
                Link Products <sup className="text-danger">*</sup>
              </label>
              <AsyncPaginate
                inputId="productSelect"
                isMulti
                placeholder="Search and select products..."
                classNamePrefix="react-select"
                additional={{ page: 1 }}
                value={(data?.productId || [])
                  .map((id) => {
                    const product = productList.find((p) => p?.id === id);
                    return product ? { value: product.id, label: product.name } : null;
                  })
                  .filter(Boolean)}
                loadOptions={loadProductOptions}
                onChange={(selectedOptions) => {
                  const selectedIds = selectedOptions
                    ? selectedOptions.map((opt) => opt.value)
                    : [];

                  setData((prev) => ({
                    ...prev,
                    productId: selectedIds,
                  }));

                  const allProducts = selectedOptions?.map((opt) => ({
                    id: opt.value,
                    name: opt.label,
                  })) || [];

                  setProductList((prevList) => {
                    const merged = [
                      ...prevList,
                      ...allProducts.filter((p) => !prevList.some((x) => x.id === p.id)),
                    ];
                    return merged;
                  });
                }}
              />
            </div>

            {/* Images */}
            <div className="col-md-6 mt-3">
              <label className="form-label">Category Banner Image</label>
              <input
                type="file"
                name="image"
                className="form-control"
                accept="image/*"
                onChange={(e) => handleImageChange(e, 'image')}
              />
              {renderImagePreview(data.imagePreview)}
            </div>

            <div className="col-md-6 mt-3">
              <label className="form-label">Category Thumbnail Image</label>
              <input
                type="file"
                name="thumbnail"
                className="form-control"
                accept="image/*"
                onChange={(e) => handleImageChange(e, 'thumbnail')}
              />
              {renderImagePreview(data.thumbnailPreview)}
            </div>

            {/* Active Toggle */}
            <div className="col-md-6 d-flex align-items-center mt-3">
              <input
                type="checkbox"
                name="active"
                checked={data.active}
                onChange={handleInputChange}
                id="active"
                style={{ marginRight: 8 }}
              />
              <label htmlFor="active" className="form-check-label mb-0">
                Active
              </label>
            </div>
          </div>

          <button type="submit" className="mybtnself" disabled={loading}>
            {loading ? 'Updating...' : 'Update Category'}
          </button>
        </form>
      </div>
    </>
  );
};

export default EditCategory;
